import { render } from "./AccordionSimpleItem.vue?vue&type=template&id=2fcda96c&scoped=true"
import script from "./AccordionSimpleItem.vue?vue&type=script&lang=js"
export * from "./AccordionSimpleItem.vue?vue&type=script&lang=js"

import "./AccordionSimpleItem.vue?vue&type=style&index=0&id=2fcda96c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fcda96c"]])

export default __exports__